function a(t, i) {
  const r = document.createElement("template");
  r.innerHTML = i.trim();
  function l(m) {
    m.querySelectorAll("script").forEach((e) => {
      var c;
      const n = document.createElement("script");
      Array.from(e.attributes).forEach((o) => {
        n.setAttribute(o.name, o.value);
      }), e.src || (n.textContent = e.textContent), (c = e.parentNode) == null || c.replaceChild(n, e);
    });
  }
  t.innerHTML = "", t.appendChild(document.importNode(r.content, !0)), l(t);
}
export {
  a as dangerouslySetInnerHtml
};
